import React from "react";
import { Route, Switch,Link,Router } from "react-router-dom";
import Privacy_policy from "./pages/Privacy_policy";
// import Faq from "./pages/Faq";
import Faqpage from "./pages/Faqpage";
import Usermanual from "./pages/Usermanual";
import OnePager from "./pages/OnePager";
import WM_Usermanual from "./pages/WM_Usermanual";
import Ref_usermanual from "./pages/Ref_usermanual";
import WM_RhineUserManual from "./pages/WM_RhineUserManual";

export default function App() {
  return (
    <>
    <Switch>
      <Route exact path='/privacypolicy' component={Privacy_policy} />
      {/* <Route exact path='/AC/FAQ' component={Faq} /> */}
      <Route exact path='/AC/FAQ' component={Faqpage} />
      <Route exact path='/AC/usermanual' component={Usermanual}/>
      <Route exact path='/AC/onepager' component={OnePager}/>
      <Route exact path='/WM/usermanual' component={WM_Usermanual}/>
      <Route exact path='/Ref/usermanual' component={Ref_usermanual}/>
      <Route exact path='/WM/rhine_usermanual' component={WM_RhineUserManual}/>
      
    </Switch>
   
    </>
  )
}